import { Component, HostListener, OnInit } from '@angular/core';
import { CoreConfigService } from '@core/services/config.service';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { PageScrollService } from 'ngx-page-scroll-core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { environment } from 'environments/environment';
import { LandingService } from '../landing.service';
import { Slider } from 'app/models/slider.model';
import { typeOperation, typeProperty } from '../../../../models/association.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss', '../stylesGlobLanding.scss']
})
export class HomeComponent implements OnInit {
  url = environment.URL_AWS;
  listSlider: Slider[] = [];
  typeProperty: typeProperty[];
  typeOperation: typeOperation[];
  domainPage: string;
  objeto:any;
  // properties;

  public isCollapsed5 = true;
  constructor(private _coreConfigService: CoreConfigService, 
    private pageScrollService: PageScrollService,
    @Inject(DOCUMENT) private document: any, 
    private _LandingService: LandingService) {
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };

    var host = window.location.host;
    const domain = host.split('.')[1];
    let data;
    if (domain == 'ampi') {
      this.domainPage = host.split('.')[0];

    } else {
      this.domainPage = window.location.host;
    }
    // this.domainPage = 'sanluispotosi';

    console.log("este es el dominio",this.domainPage);

  }

  bedrooms: any[] = [
    { name: '0', value: 0 },
    { name: '1', value: 1 },
    { name: '2', value: 2 },
    { name: '3', value: 3 },
    { name: '4 o más', value: 4 },
  ];

  bathrooms: any[] = [
    { name: '0', value: 0 },
    { name: '0.5', value: 0.5 },
    { name: '1', value: 1 },
    { name: '1.5', value: 1.5 },
    { name: '2', value: 2 },
    { name: '2.5', value: 2.5 },
    { name: '3', value: 3 },
    { name: '3.5', value: 3.5 },
    { name: '4 o más', value: 4 },
  ];

  garageOpt: any[] = [
    { name: '0', value: 0 },
    { name: '1', value: 1 },
    { name: '2', value: 2 },
    { name: '3', value: 3 },
    { name: '4 o más', value: 4 },
  ];

  jardinOpts = [
    { name: 'Si', value: 1 },
    { name: 'No', value: 0 },
  ];

  ngOnInit(): void {
    var host = window.location.host;
    const domain = host.split('.')[1];
    let data;
    if (domain == 'ampi') {
      this.domainPage = host.split('.')[0];

    } else {
      this.domainPage = window.location.host;
    }

    // this.domainPage = 'sanluispotosi';
    console.log("este es el dominio", this.domainPage);

    this.typeProperty = [
      {
        id: 1,
        name: 'Casa'
      },
      {
        id: 2,
        name: 'Departamento'
      },
      {
        id: 3,
        name: 'Comercio'
      },
      {
        id: 5,
        name: 'Terreno'
      },
      {
        id: 6,
        name: 'Bodega/nave'
      },
      {
        id: 7,
        name: 'Campestre/Rancho'
      },
      {
        id: 8,
        name: 'Oficina'
      },
      {
        id: 9,
        name: 'Edificio'
      }
    ]

    this.typeOperation = [
      {
        id: 1,
        name: 'Renta'
      },
      {
        id: 2,
        name: 'Venta'
      },
    ]


    this._LandingService.getServer('getSlider', this.domainPage).then(
      (resp: Slider[]) => {
        this.listSlider = resp;
        console.log(this.listSlider)
      }, (error: any) => {
        console.log("ERROR", error);
      }
    );
    
    this._LandingService.getServer('usAssociation', this.domainPage).then(
      (resp: any) => {
        this.objeto = resp;
        console.log(resp)

      }, (err: any) => {
        console.log("ERROR ", err);
      }
    );

    /* this._LandingService.getServer('getProperties', this.domainPage).then(
      (resp:any) => {
        this.properties.data = resp;
        this.sizeTable = resp.total;
        this.pageSize = 8;
        console.log('RESPUESTA getProperties', resp)
      }, (error: any) => {
        console.log("ERROR getProperties", error);
      }
    ); */


    if (localStorage.getItem('sectionMenu')) {
      setTimeout(() => {
        switch (localStorage.getItem('sectionMenu')) {
          case '1':
            this.itemMenu(1);
            break;
          case '2':
            this.itemMenu(2);
            break;
          case '3':
            this.itemMenu(3);
            break;
          case '4':
            this.itemMenu(4);
            break;
          case '5':
            this.itemMenu(5);
            break;
          case '6':
            this.itemMenu(6);
            break;
          case '7':
            this.itemMenu(7);
            break;
          case '8':
            this.itemMenu(8);
            break;
        }

        localStorage.removeItem('sectionMenu');
      }, 500);

    }



  }

  itemMenu(optionMenu: number) {

    let stringOptionMenu = null;

    switch (optionMenu) {
      case 1:
        stringOptionMenu = '#propertiesSection';
        break;
      case 2:
        stringOptionMenu = '#usSection';
        break;
      case 3:
        stringOptionMenu = '#partnersSection';
        break;
      case 4:
        stringOptionMenu = '#benefitsSection';
        break;
      case 5:
        stringOptionMenu = '#eventsSection';
        break;
      case 6:
        stringOptionMenu = '#partnersSection';
        break;
      case 7:
        stringOptionMenu = '#affiliatesSection';
        break;
      case 8:
        stringOptionMenu = '#mesaDirectivaSection';
        break;
    }

    this.pageScrollService.scroll({
      document: this.document,
      scrollTarget: stringOptionMenu,
    });

  }

  public swiperFadeEffect: SwiperConfigInterface = {
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: true,
    grabCursor: true,
    effect: 'fade',
    autoplay: {
      delay: 2500,
      disableOnInteraction: false
    },
    centeredSlides: true,
    shortSwipes: false

  };

  sendWhatsapp(){
    let telefono = this.objeto.phone;
    return window.open('https://api.whatsapp.com/send?phone='+telefono, '_blank');
  }
}
